<template>
  <div class="d-flex d-inline">
    <!--begin::Navigation-->
      <div class="">
        <v-btn text small  @click="$emit('removeNote')">
          <v-icon color="#B31414">mdi-delete-empty</v-icon>
        </v-btn>
      </div>
    <div class="" v-if="!inEditMode">
      <v-btn text small class="" @click="$emit('editMode')">
        <v-icon color="#FF8000">mdi-pencil</v-icon>

      </v-btn>
    </div>
    <!--end::Navigation-->
  </div>
</template>

<script>
export default {
  name: "EditAndDeleteBtn",
  props: ['inEditMode'],

}
</script>

<style scoped>

</style>